"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tree = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
var TriStateCheckbox_1 = require("../../components/TriStateCheckbox");
var ErrorBoundary_1 = require("../../components/ErrorBoundary");
require("./Tree.css");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var Row_1 = require("../../components/Row");
var Popover_1 = require("../../components/Popover");
var Tree = function (props) {
  var treeStructure = props.treeStructure,
    labelContent = props.labelContent,
    infoContent = props.infoContent,
    _a = props.rootVisible,
    rootVisible = _a === void 0 ? false : _a,
    _b = props.expanded,
    expanded = _b === void 0 ? {} : _b,
    _c = props.selected,
    selected = _c === void 0 ? {} : _c,
    filterOut = props.filterOut,
    highlight = props.highlight,
    className = props.className,
    _d = props.fixedWidth,
    fixedWidth = _d === void 0 ? false : _d,
    _e = props.onSelectionToggle,
    onSelectionToggle = _e === void 0 ? R.N : _e,
    _f = props.onExpansionToggle,
    onExpansionToggle = _f === void 0 ? R.N : _f,
    _g = props.arrows,
    arrows = _g === void 0 ? true : _g,
    restProps = __rest(props, ["treeStructure", "labelContent", "infoContent", "rootVisible", "expanded", "selected", "filterOut", "highlight", "className", "fixedWidth", "onSelectionToggle", "onExpansionToggle", "arrows"]);
  var cn = (0, classnames_1.default)("vsx-tree", fixedWidth && "vsx-fixedWidth", className);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, R.omit(["setExpanded", "setSelected", "setFilteredOut", "select", "expand"], restProps), {
    className: cn
  }, {
    children: (0, jsx_runtime_1.jsx)(TreeNode, {
      arrows: arrows,
      treeStructure: treeStructure,
      labelContent: labelContent,
      rootVisible: rootVisible,
      selected: selected,
      expanded: expanded,
      filterOut: filterOut,
      highlight: highlight,
      onSelectionToggle: onSelectionToggle,
      onExpansionToggle: onExpansionToggle
    })
  }));
};
exports.Tree = Tree;
var TreeNode = function (props) {
  var treeStructure = props.treeStructure,
    _labelContent = props.labelContent,
    _infoContent = props.infoContent,
    _a = props.rootVisible,
    rootVisible = _a === void 0 ? false : _a,
    _b = props.expanded,
    expansion = _b === void 0 ? {} : _b,
    _c = props.selected,
    selection = _c === void 0 ? {} : _c,
    _d = props.filterOut,
    filterOut = _d === void 0 ? {} : _d,
    highlight = props.highlight,
    className = props.className,
    onSelectionToggle = props.onSelectionToggle,
    onExpansionToggle = props.onExpansionToggle,
    __nodeId = props._nodeId,
    arrows = props.arrows,
    restProps = __rest(props, ["treeStructure", "labelContent", "infoContent", "rootVisible", "expanded", "selected", "filterOut", "highlight", "className", "onSelectionToggle", "onExpansionToggle", "_nodeId", "arrows"]);
  var _nodeId = __nodeId !== null && __nodeId !== void 0 ? __nodeId : treeStructure.rootId();
  var cn = (0, classnames_1.default)("vsx-node", filterOut[_nodeId] && "vsx-hidden");
  var labelContent = _labelContent || treeStructure.name;
  var infoContent = _infoContent || treeStructure.info;
  var children = function (id, context) {
    var _a;
    return (_a = treeStructure.children(id, context)) !== null && _a !== void 0 ? _a : [];
  };
  var onSelectionClick = function (event) {
    event.stopPropagation();
    onSelectionToggle(_nodeId);
  };
  var onDetailsClick = function (event) {
    event.preventDefault();
    event.stopPropagation();
    onExpansionToggle(_nodeId);
  };
  var isParent = children(_nodeId).length > 0;
  var expanded = expansion[_nodeId];
  var icon = (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    style: {
      visibility: isParent ? "visible" : "hidden",
      cursor: "pointer"
    },
    onClick: isParent ? onDetailsClick : R.N,
    rotation: expanded ? "180deg" : "90deg",
    size: "0.8em",
    icon: "triangle"
  });
  var info = infoContent(_nodeId, highlight);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, transformToDivProps(restProps), {
    className: cn
  }, {
    children: rootVisible ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        gap: "medium",
        justify: "space-between",
        align: "center",
        className: "vsx-leafContent",
        onClick: isParent ? onDetailsClick : onSelectionClick
      }, {
        children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
          gap: "medium",
          align: "center"
        }, {
          children: [arrows && (0, jsx_runtime_1.jsx)("span", {
            children: icon
          }), (0, jsx_runtime_1.jsx)(TriStateCheckbox_1.TriStateCheckbox, {
            className: "vsx-treecheckbox",
            value: selection[_nodeId],
            onClick: onSelectionClick
          }), (0, jsx_runtime_1.jsx)("span", {
            children: labelContent(_nodeId, highlight)
          })]
        })), info && (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
          content: info,
          interactive: false,
          tooltip: true,
          placement: "left"
        }, {
          children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            icon: "information-outline"
          })
        }))]
      })), isParent && expanded && (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-treeChildren"
      }, {
        children: children(_nodeId).map(function (_nodeId) {
          return (0, react_1.createElement)(TreeNode, __assign({}, __assign(__assign({}, props), {
            _nodeId: _nodeId
          }), {
            key: _nodeId,
            rootVisible: true
          }));
        })
      }))]
    }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
      children: children(_nodeId).map(function (_nodeId) {
        return (0, react_1.createElement)(TreeNode, __assign({}, __assign(__assign({}, props), {
          _nodeId: _nodeId
        }), {
          key: _nodeId,
          rootVisible: true
        }));
      })
    })
  }));
};
var transformToDivProps = function (props) {
  var cloneProps = R.clone(props);
  cloneProps["_nodeid"] = props["_nodeId"];
  delete cloneProps["_nodeId"];
  delete cloneProps["labelContent"];
  return cloneProps;
};
exports.default = (0, ErrorBoundary_1.withErrorBoundary)(TreeNode);